<script setup>
defineProps({
  itemDetalhes: { type: Object, required: true },
  listas: { type: Object, required: true },
  formatarValor: { type: Function, default: (v) => v },
  getTextoLista: { type: Function, default: (l, id) => id || '-' },
  formatarMoedaComSigla: { type: Function, default: (v, m) => `${v} ${m}` }
})
</script>

<template>
  <!-- Resumo em destaque (primeiro) -->
  <div class="bg-body-tertiary border rounded p-2 mb-3">
    <small class="text-body-secondary d-block lh-1 mb-1 fw-bold">
      <i class="bi bi-chat-quote me-1 text-info"></i> Resumo
    </small>
    <p class="mb-0 text-body-secondary small">{{ itemDetalhes.resumoAprovacao || 'Nenhum resumo registrado.' }}</p>
    <small v-if="itemDetalhes.nomeUsuarioCriacao" class="text-body-secondary d-block mt-1 small">
      <i class="bi bi-person-fill me-1 text-info"></i> Criado por: <span class="fw-medium">{{ itemDetalhes.nomeUsuarioCriacao }}</span>
    </small>
  </div>

  <!-- Grid compacto de informações-chave -->
  <div class="row g-2 mb-3">
    <div class="col-6 col-md-3">
      <div class="border rounded p-2 h-100 bg-body-tertiary">
        <small class="text-body-secondary d-block lh-1 mb-1">Fornecedor</small>
        <span class="fw-medium text-body-emphasis small">{{ itemDetalhes.nomeFornecedor || '-' }}</span>
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="border rounded p-2 h-100 bg-body-tertiary">
        <small class="text-body-secondary d-block lh-1 mb-1">Valor Total</small>
        <span class="fw-medium text-body-emphasis small">{{ formatarMoedaComSigla(itemDetalhes.valorTotalNegociado, itemDetalhes.lstMoedaPadrao) }}</span>
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="border rounded p-2 h-100 bg-body-tertiary">
        <small class="text-body-secondary d-block lh-1 mb-1">Status</small>
        <span class="badge badge-ghost-info">{{ getTextoLista(listas.LstStatusOrdemCompra, itemDetalhes.lstStatusOrdemCompra) }}</span>
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="border rounded p-2 h-100 bg-body-tertiary">
        <small class="text-body-secondary d-block lh-1 mb-1">Grupo Aprovador</small>
        <span class="fw-medium text-body-emphasis small">{{ itemDetalhes.nomeGrupoAprovador || '-' }}</span>
      </div>
    </div>
  </div>

  <!-- Itens com scroll próprio -->
  <div class="mb-2">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <small class="fw-bold text-body-emphasis">
        <i class="bi bi-list-check me-1 text-info"></i> Itens ({{ itemDetalhes.itens?.length || 0 }})
      </small>
    </div>
    <div v-if="itemDetalhes.itens && itemDetalhes.itens.length > 0" class="itens-scroll-wrapper border rounded bg-body-tertiary p-1">
      <div
        v-for="(item, idx) in itemDetalhes.itens"
        :key="idx"
        class="d-flex flex-wrap align-items-center gap-2 px-2 py-1 border-bottom border-secondary-subtle item-row"
        :class="{ 'border-bottom-0': idx === itemDetalhes.itens.length - 1 }"
      >
        <div class="fw-medium text-body-emphasis" style="min-width: 140px; flex: 1;">
          <span class="small">{{ item.nomeProduto || item.sku || 'Produto #' + item.idProduto }}</span>
          <small v-if="item.sku && item.nomeProduto" class="text-body-secondary d-block" style="font-size: 0.7rem;">SKU: {{ item.sku }}</small>
          <small v-else-if="!item.sku && !item.nomeProduto && item.idProduto" class="text-body-secondary d-block" style="font-size: 0.7rem;">ID: {{ item.idProduto }}</small>
        </div>
        <div class="text-body-secondary small text-nowrap">
          {{ formatarValor(item.quantidadePedidaUnFornecedor) }} {{ getTextoLista(listas.LstUnidadeMedidaFornecedor, item.lstUnidadeMedidaFornecedor) }}
        </div>
        <div class="text-body-emphasis fw-medium small text-nowrap ms-auto">
          {{ formatarMoedaComSigla(item.valorTotalNegociado, itemDetalhes.lstMoedaPadrao) }}
        </div>
      </div>
    </div>
    <div v-else class="text-center text-body-secondary small py-2">
      Nenhum item registrado.
    </div>
  </div>
</template>

<style scoped>
.itens-scroll-wrapper {
  max-height: 220px;
  overflow-y: auto;
}

.itens-scroll-wrapper::-webkit-scrollbar {
  width: 6px;
}

.itens-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: var(--bs-border-color);
  border-radius: 3px;
}

.item-row:last-child {
  border-bottom: none !important;
}
</style>
